import React, { useState, useEffect } from 'react';
import axios from 'axios'; // To make HTTP requests
import { Doughnut } from 'react-chartjs-2'; // Doughnut chart component from chart.js
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale } from 'chart.js'; // Import necessary Chart.js components
import { Link, Route, Routes, useNavigate } from 'react-router-dom'; // Import Link and useNavigate from react-router-dom for navigation
import './projectmanager_dashboard.css'; // Import custom styles
import TaskUpdateForm from './Taskupdate';
import TaskAssignmentForm from './Taskassignmentretrival';
import EmployeeProductivityManager from './Employeeproductivityformanager';

// Register necessary Chart.js components
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale
);

const ProjectManagerPage = () => {
  const [projectData, setProjectData] = useState({
    labels: ['Active', 'Pending', 'Completed'],
    datasets: [
      {
        data: [50, 30, 20], // Initial values (Project data)
        backgroundColor: ['#D0A6C4', '#A2D2FF', '#FAD02E'], // Light colors for the sections
      },
    ],
  });

  const [isLoading, setIsLoading] = useState(true); // To handle loading state
  const [empId, setEmpId] = useState(''); // State for employee ID
  const [empName, setEmpName] = useState(''); // State for employee Name
  const [designation, setDesignation] = useState(''); // State for employee Designation
  const navigate = useNavigate(); // For navigating to the login page

  // Fetch project data (combined data for project overview)
  const fetchProjectData = async () => {
    try {
      const response = await axios.get('https://cleezoclass.com:8443/api/project-data');
      const { activeProjects, pendingProjects, completedProjects } = response.data;

      setProjectData({
        labels: ['Active', 'Pending', 'Completed'],
        datasets: [
          {
            data: [activeProjects, pendingProjects, completedProjects],
            backgroundColor: ['#D0A6C4', '#A2D2FF', '#FAD02E'], // Light colors for the sections
          },
        ],
      });
      setIsLoading(false); // Data is loaded
    } catch (error) {
      console.error('Error fetching project data:', error);
      setIsLoading(false); // In case of error, stop loading
    }
  };

  // Fetch the data when the component mounts
  useEffect(() => {
    // Load employee details from localStorage
    const storedEmpId = localStorage.getItem('empId');
    const storedEmpName = localStorage.getItem('empName');
    const storedDesignation = localStorage.getItem('designation');

    // Check if employee details exist in localStorage and update state
    if (!storedEmpId || !storedEmpName || !storedDesignation) {
      alert('Session expired. Please log in again.');
      navigate('/'); // Redirect to homepage (or login page) after showing the alert
    } else {
      setEmpId(storedEmpId);
      setEmpName(storedEmpName);
      setDesignation(storedDesignation);
      // Fetch project data after loading employee details
      fetchProjectData();
    }
  }, [navigate]); // Re-run the effect if navigate changes (if needed)

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem('empId');
    localStorage.removeItem('empName');
    localStorage.removeItem('designation');
    navigate('/'); // Redirect to homepage after logout
  };

  return (
    <div className=" mainBlock">
      {/* Header */}
      {/* <div className="project-manager-dashboard-header">
        Project Manager Dashboard
      </div> */}

    

      {/* Section Box */}
      <div className="project-manager-dashboard-section-box">
        {/* Heading inside the section box */}
        <h3>Project and Task Management</h3>

        {/* Doughnut Chart */}
        <div className="project-manager-dashboard-chart-container">
          {isLoading ? (
            <div className="project-manager-dashboard-loading">Loading project data...</div> // Loading indicator
          ) : (
            <Doughnut data={projectData} />
          )}
        </div>

        {/* Project Details */}
        {/* <div className="project-manager-dashboard-details">
          <p>Project Overview</p>
          <Link to="/Taskupdate" className="project-manager-dashboard-crm-link">Team Task Update</Link>
          <Link to="/Taskassignmentretrival" className="project-manager-dashboard-crm-link">Task Assignment</Link>
          <Link to="/Employeeproductivityformanager" className="project-manager-dashboard-crm-link">Employee Productivity</Link>
        </div> */}
      <Routes>
        <Route path="/Taskupdate" element={<TaskUpdateForm />} />
        <Route path="/Taskassignmentretrival" element={<TaskAssignmentForm />} />
        <Route path="/Employeeproductivityformanager" element={<EmployeeProductivityManager />} />

      </Routes>
      </div>
    </div>
  );
};

export default ProjectManagerPage;
